import { useLocaleState, useRecordContext } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";

import { StatusBadge } from "../faromarket-shared/StatusBadge";
import { formatRelativeDate } from "../misc/RelativeDate";

const TASK_TYPE_CHOICES = [
  { id: "triage", name: "crm.faromarket.task_type.triage" },
  { id: "follow_up", name: "crm.faromarket.task_type.follow_up" },
  { id: "proposal", name: "crm.faromarket.task_type.proposal" },
  { id: "meeting", name: "crm.faromarket.task_type.meeting" },
  { id: "call", name: "crm.faromarket.task_type.call" },
  { id: "email", name: "crm.faromarket.task_type.email" },
  { id: "reactivation", name: "crm.faromarket.task_type.reactivation" },
  { id: "internal", name: "crm.faromarket.task_type.internal" },
];

const PRIORITY_CHOICES = [
  { id: "low", name: "crm.faromarket.task_priority.low" },
  { id: "medium", name: "crm.faromarket.task_priority.medium" },
  { id: "high", name: "crm.faromarket.task_priority.high" },
  { id: "urgent", name: "crm.faromarket.task_priority.urgent" },
];

const TaskFilters = [
  <SearchInput source="text@ilike" alwaysOn />,
  <SelectInput
    source="task_type"
    choices={TASK_TYPE_CHOICES}
    translateChoice
  />,
  <SelectInput source="priority" choices={PRIORITY_CHOICES} translateChoice />,
];

const PriorityField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.priority} kind="task_priority" />;
};

const TaskTypeField = () => {
  const record = useRecordContext();
  if (!record?.task_type)
    return <span className="text-muted-foreground">—</span>;
  return <span className="text-sm">{record.task_type}</span>;
};

const DoneField = () => {
  const record = useRecordContext();
  if (record?.done_date) {
    return (
      <span className="text-emerald-700 dark:text-emerald-300 text-sm">
        Concluída
      </span>
    );
  }
  return <span className="text-amber-700 dark:text-amber-300 text-sm">Pendente</span>;
};

const RelativeDateField = ({ source }: { source: string }) => {
  const record = useRecordContext();
  const [locale = "pt-BR"] = useLocaleState();
  const value = record?.[source];
  if (!value) return <span className="text-muted-foreground">—</span>;
  return <span>{formatRelativeDate(value, locale)}</span>;
};

export const TaskList = () => (
  <List
    perPage={25}
    sort={{ field: "due_date", order: "ASC" }}
    filter={{ is_test: false }}
    filters={TaskFilters}
  >
    <DataTable>
      <DataTable.Col source="text" label="resources.tasks.fields.text" />
      <DataTable.Col
        source="task_type"
        label="resources.tasks.fields.type"
      >
        <TaskTypeField />
      </DataTable.Col>
      <DataTable.Col source="priority" label="Prioridade">
        <PriorityField />
      </DataTable.Col>
      <DataTable.Col
        source="contact_id"
        label="resources.tasks.fields.contact_id"
      >
        <ReferenceField
          source="contact_id"
          reference="contacts"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col source="company_id" label="Empresa">
        <ReferenceField
          source="company_id"
          reference="companies"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col source="lead_id" label="Lead">
        <ReferenceField
          source="lead_id"
          reference="leads"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col source="deal_id" label="Oportunidade">
        <ReferenceField
          source="deal_id"
          reference="deals"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col
        source="due_date"
        label="resources.tasks.fields.due_date"
      >
        <RelativeDateField source="due_date" />
      </DataTable.Col>
      <DataTable.Col source="done_date" label="Status">
        <DoneField />
      </DataTable.Col>
    </DataTable>
  </List>
);
